var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-primary",style:(`background-color: ${_vm.percentageColor};`)},[_vm._v("\n  "+_vm._s(_vm._f("percentage")(_vm.value))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }